import React from "react";
import ExecDashboard from "./ExecDashboard";

export default function App() {
  return (
    <div className="App">
      <ExecDashboard />
    </div>
  );
}
